import { CreateServicesHubDto } from '../../../../types/serviceHub.types';
import { useEffect, useState } from 'react';
import { API } from '../../../../api/api';
import { URLS } from '../../../../api/urls';
import { useAlert } from '../../../../context/Alert.context';
import { ALERT_TEXT } from '../../../../constants/content';

export const useServiceHubModal = (serviceInfoId?: string, onClose?: () => void) => {
  const [serviceHubData, setServiceHubData] = useState<CreateServicesHubDto | null>(null);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();
  const [actionLoading, setActionLoading] = useState(false);
  useEffect(() => {
    API.get<CreateServicesHubDto>(`${URLS.SERVICE_HUB}/getByServiceInfoId/${serviceInfoId}`)
      .then(({ data }) => {
        if(!data) setServiceHubData(null);
        setServiceHubData(data)
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() =>
        setLoading(false)
      );
  }, []);

  const action = (data: CreateServicesHubDto) => {
    const formData = new FormData();
    formData.append('fileInfo', data.fileInfo as File);
    formData.append('slug', data.slug || '');
    formData.append('serviceNameEn', data.serviceNameEn || '');
    formData.append('serviceNameUk', data.serviceNameUk || '');
    formData.append('serviceNameRu', data.serviceNameRu || '');
    formData.append('serviceNamePl', data.serviceNamePl || '');

    formData.append('serviceSubtitleEn', data.serviceSubtitleEn || '');
    formData.append('serviceSubtitleRu', data.serviceSubtitleRu || '');
    formData.append('serviceSubtitleUk', data.serviceSubtitleUk || '');
    formData.append('serviceSubtitlePl', data.serviceSubtitlePl || '');

    formData.append('serviceShortnamePl', data.serviceShortnamePl || '');
    formData.append('serviceShortnameUk', data.serviceShortnameUk || '');
    formData.append('serviceShortnameRu', data.serviceShortnameRu || '');
    formData.append('serviceShortnameEn', data.serviceShortnameEn || '');

    formData.append('seoTitleEn', data.seoTitleEn || '');
    formData.append('seoTitlePl', data.seoTitlePl || '');
    formData.append('seoTitleRu', data.seoTitleRu || '');
    formData.append('seoTitleUk', data.seoTitleUk || '');

    formData.append('seoDescriptionUk', data.seoDescriptionUk || '');
    formData.append('seoDescriptionRu', data.seoDescriptionRu || '');
    formData.append('seoDescriptionEn', data.seoDescriptionEn || '');
    formData.append('seoDescriptionPl', data.seoDescriptionPl || '');

    formData.append('serviceInfoId', serviceInfoId || '');

    formData.append('faqPl', JSON.stringify(data.faqPl ?? []));
    formData.append('faqEn', JSON.stringify(data.faqEn ?? []));
    formData.append('faqUk', JSON.stringify(data.faqUk ?? []));
    formData.append('faqRu', JSON.stringify(data.faqRu ?? []));
    if(!serviceHubData) {
      API.post(URLS.SERVICE_HUB, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          onClose && onClose();
          showAlert({
            message: ALERT_TEXT.SERVICE_HUB_CREATED_SUCCESS,
            severity: 'success',
          });
        })
        .catch((e) => showAlert({ message: e.response?.data?.message || e.message, severity: 'error' }));
    } else {
      API.put(`${URLS.SERVICE_HUB}/${serviceHubData.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          onClose && onClose();
          showAlert({
            message: ALERT_TEXT.SERVICE_HUB_UPDATED_SUCCESS,
            severity: 'success',
          });
        })
        .catch((e) => showAlert({ message: e.response?.data?.message || e.message, severity: 'error' }));
    }
  }

  return { serviceHubData, loading, action, actionLoading };
}